import React, { useState } from 'react';
import { endpoints } from '@/constants/urls';
import ExternalLinksLogoWrapper from './ExternalLinksLogoWrapper';

const ExternalLinksLogo = ({ linksName }) => {
  const [skip, setSkip] = useState(false);

  return (
    <ExternalLinksLogoWrapper
      linksName={linksName}
      className={skip ? 'aridhia-external-links-name-no-image' : 'aridhia-external-links-name'}
    >
      {!skip && (
      <img
        src={`${endpoints.API_IMAGES}fair-external-links.svg`}
        className="aridhia-external-links-logo ui image logo mini"
        alt={linksName}
        onError={() => setSkip(true)}
      />
      )}
    </ExternalLinksLogoWrapper>
  );
};

export default ExternalLinksLogo;
